import * as React from "react";
const SvgManualPutaway20Px = (props) =>
  React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        fill: "black",
        viewBox: "0 0 20 20"
      },
      props
    ),
    React.createElement("path", {
      fill: "current",
      fillRule: "evenodd",
      d: "M17 17v-6.147H3V17H1V1h18v16h-2Zm0-14H3v2h8.046V3.667H15V5h2V3ZM3 9.353V6.5h14v2.853H8.968V7.32h-5v2.033H3Z",
      clipRule: "evenodd"
    }),
    React.createElement("path", {
      fill: "current",
      d: "M11.032 20v-4.596l1.9 1.868 1.414-1.414-3.607-3.575-.707-.707-4.281 4.281 1.414 1.415 1.867-1.868V20h2Z"
    })
  );
export default SvgManualPutaway20Px;
